
export const getTime = (dateSrting) =>
    new Date(dateSrting).toLocaleDateString([], {
        hour: 'numeric',
        minute: 'numeric',
    }).split(',')[1].trim();

